import React, { useEffect, useState } from "react";
import "jsvectormap/dist/maps/world.js";
import "jsvectormap/dist/css/jsvectormap.min.css";
import {
  Card,
  CardBody,
  CardExpandToggler,
  CardHeader,
} from "./../components/card/card.jsx";
import { useDispatch, useSelector } from "react-redux";
import ButtonComponent from "../components/ButtonComponent.jsx";
import { openDetail, openForm } from "../redux/slice/cameraSlice";
import FormCamera from "../form-data-master/FormCamera.jsx";
import { getCameraPage } from "../redux/action/cameraAction.js";
import DatatableComponent from "../components/DatatableComponent.jsx";
import { getRoleModuleById, getRoleModulePage } from "../redux/action/roleModuleAction.js";
import { InputNonForm, SelectNonForm } from "../components/InputComponent.jsx";
import { useLocation } from "react-router-dom";
import findItem from "../helperFindPath.js";
import FormDetailCamera from "../form-data-master/FormDetailCamera.jsx";
import { getSitesList } from "../redux/action/sitesAction.js";

function Camera() {
  const { dataCamera, isOpenCamera, isLoading, isOpenDetail } = useSelector( (state) => state.camera );
  const { dataRoleModule } = useSelector((state) => state.roleModule);
  const { dataSitesList } = useSelector( (state) => state.sites );
  const [filterSites, setFilterSites] = useState('')
  const [optionSites, setOptionSites] = useState([])
  const dispatch = useDispatch();
  const [page, setPage] = useState(0)
  const [sort, setSort] = useState('')
  const [select, setSelect] = useState('')
  const [filter, setFilter] = useState(([
    { name: '', brand: '', type: '', location: '', siteName: filterSites },
  ]))
  const countPerPage = 10
  const { user } = useSelector((state) => state.auth);
  const param = { 
    token: user.access_token,
    sort: sort,
    size: countPerPage,
    select: select,
    filter: filter,
    page: page,
   };
   const resetFilter = () => {
    setFilter([{ name: '', brand: '', type: '', location: '', siteName: '' }])
  }


  const newSites = () => {
    // console.log(dataSupervisor)
    let arr = [{ name: '- PILIH SITES -', id: '' }]
    dataSitesList.map((row, index) => {
      arr.push({ name: row.siteName, id: row.siteName })
    })
    setOptionSites(arr)
  }
  useEffect(() => {
    newSites()
  }, [])
  useEffect(() => {
    if (dataSitesList.length > 0) {
      newSites()
    }
  }, [dataSitesList])
   const onChange = async (e, field) => {
    // console.log(e.target.value)
    let arr = [...filter]
    if (field === 'name') {
      arr[0].name = e.target.value.toUpperCase()
    }
    if (field === 'brand') {
      arr[0].brand = e.target.value.toUpperCase()
    }
    // if (field === 'type') {
    //   arr[0].type = e.target.value.toUpperCase()
    // }
    if (field === 'location') {
      arr[0].location = e.target.value.toUpperCase()
    }
    if (field === 'siteName') {
      arr[0].siteName = e.target.value
      setFilterSites(e.target.value)
    }
    setFilter(arr)
    // console.log(filter)
  }
  
   const columns = [
    // {
    //   name: 'ID Kamera',
    //   selector: (row) => row.id,
    //   sortable: true,
    // },
    {
      name: (
        <div>
          Nama Kamera
          <InputNonForm
            type="text"
            value={filter[0].name}
            onChange={(e) => onChange(e, 'name')}
            style={{ width: '100%' }}
            className="form-control form-control-sm"
          />
        </div>
      ),
      selector: (row) => row.name,
    },
    {
      name: (
        <div>
          Merek Kamera
          <InputNonForm
            type="text"
            value={filter[0].brand}
            onChange={(e) => onChange(e, 'brand')}
            style={{ width: '100%' }}
            className="form-control form-control-sm"
          />
        </div>
      ),
      selector: (row) => row.brand,
    },
    // {
    //   name: (
    //     <div>
    //       Tipe Kamera
    //       <InputNonForm
    //         type="text"
    //         value={filter[0].type}
    //         onChange={(e) => onChange(e, 'type')}
    //         style={{ width: '100%' }}
    //         className="form-control form-control-sm"
    //       />
    //     </div>
    //   ),
    //   selector: (row) => row.type,
    // },
    {
      name: (
        <div>
          Lokasi Kamera
          <InputNonForm
            type="text"
            value={filter[0].location}
            onChange={(e) => onChange(e, 'location')}
            style={{ width: '100%' }}
            className="form-control form-control-sm"
          />
        </div>
      ),
      selector: (row) => row.location,
    },
    {
      name: (
        <div>
          Lokasi JPO
          <SelectNonForm 
            onChange={(e) => onChange(e, 'siteName')}
            // onChange={(e) => {
            //   setFilterSites(e.target.value)
            // }}
            // onChange={(e) => onChangeDropdown(
            //      setFilterSites(e.target.value)
            //   )}
            name="type"
            id="type"
            value={filter[0].siteName}
            option={optionSites}  
          />
        </div>
      ),
      selector: (row) => row.detailSite.siteName,
    },
    {
      name: 'Action',
      cell: (row) => (
        <div style={{ padding: '10px 0' }}>
          {dataByIdRoleModule !== '' ? dataByIdRoleModule.read ? (
            <ButtonComponent
            onClick={(e) => dispatch(openDetail({ open: true, id: row.id, data: row }))}
            color="#fff"
              backgroundColor="#3c484f"
              backgroundHover="#db4912"
          >
            <i className="fas fa-eye" title="Lihat Detail Kamera"/>
          </ButtonComponent> ): null : null}
          {dataByIdRoleModule !== '' ? dataByIdRoleModule.update ? (
            <ButtonComponent
              onClick={(e) =>
                  dispatch(openForm({ state: 'edit', open: true, id: row.id, data: row }))
              }
              color="#fff"
              backgroundColor="#3c484f"
              backgroundHover="#db4912"
              >
              <i className="fas fa-pencil-alt" title='Ubah Data Kamera' style={{ paddingRight: '5px'}}/> 
            </ButtonComponent>): null : null}
            {dataByIdRoleModule !== '' ? dataByIdRoleModule.delete ? (
            <ButtonComponent
              onClick={(e) =>
                  dispatch(openForm({ state: 'delete', open: true, id: row.id, data: row }))
              }
              color="#fff"
              backgroundColor="#3c484f"
              backgroundHover="#db4912"
              >
              <i className="fas fa-trash" title='Hapus Data Kamera' />
            </ButtonComponent>): null : null }
        </div>
      ),
    },
  ]

  useEffect(() => {
    dispatch(getRoleModulePage({ roleId: user.user_id , token: param.token}));
    dispatch(getSitesList(param));
  }, []);
  useEffect(() => {
    dispatch(getCameraPage(param));
  }, [page, filter, select, sort]);
  const {dataRoleModuleSidebar, dataByIdRoleModule} = useSelector((state)=>state.roleModule)
  const { pathname } = useLocation();
  const [ dataObjPath, setDataObjPath] = useState('')
  useEffect(() => {
    if(dataObjPath !== ''){
      param.id = dataObjPath.id
      dispatch(getRoleModuleById(param))
    }
    // eslint-disable-next-line
  }, [dataObjPath]);
  useEffect(()=>{
    if(dataRoleModuleSidebar.length > 0){
      const findPath = findItem(dataRoleModuleSidebar, pathname)
      // console.log(findPath)
      if(findPath !== null){
        setDataObjPath(findPath) 
      }else{
        setDataObjPath('403')
      }
    }
  },[dataRoleModuleSidebar])

  if(dataObjPath === ''){
    return (
      null
    )
  }else if(dataObjPath === '403'){
    return (
      <div>
        <h2>403: Forbidden</h2>
        <p>Anda Tidak Memiliki Hak Akses Untuk Halaman Ini</p>
      </div>
    )
  }else{
    return (
      <div>
      <h4> Daftar Kamera</h4>
      <div className="row">
        <div className="col-xl-12">
          <Card className="mb-3">
            <CardHeader style={{ borderBottom: "none" }}>
              <div className="row">
                <div className="col-xl-6">
                  {/* <span style={{ fontSize: "1rem" }}> Camera </span>
                  <span className="text-secondary"> List </span> */}
                </div>
                <div className="col-xl-6" style={{ textAlign: 'right', alignSelf: 'center' }}>
                      <ButtonComponent
                        onClick={() => resetFilter()}
                        color="white"
                        backgroundColor="#3003fc"
                        backgroundHover="#2404b5"
                        style={{ marginRight: 5 }}
                      >
                        <i className="fas fa-history"/> Reset
                      </ButtonComponent>
                        {dataByIdRoleModule.create ? (
                          <ButtonComponent
                            onClick={() => dispatch(openForm({ open: true, state: 'add' }))}
                            color="white"
                            backgroundColor="#3003fc"
                            backgroundHover="#2404b5"
                          >
                            + Tambah 
                          </ButtonComponent>
                        ): null}
                    </div>
              </div>
            </CardHeader>
            {dataByIdRoleModule.read ? (
            <CardBody>
              <DatatableComponent
                data={dataCamera}
                page={page}
                countPerPage={countPerPage}
                columns={columns}
                setPage={setPage}
              />
            </CardBody>
            ):null}
          </Card>
        </div>
      </div>
      <FormCamera param={param} />
      <FormDetailCamera param={param} />
    </div>
    );
  }
}

export default Camera;
